var map = {
	"./1.png": 529090,
	"./2.png": 972831,
	"./3.png": 742473,
	"./4.png": 922227,
	"./5.png": 691731,
	"./6.png": 150145,
	"./7.png": 838281,
	"./8.png": 396854,
	"./_1.png": 982489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172483;